import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        modalEdit: false,
        user: {
            idUser: "",
            nama: "",
            nipBaru: "",
            unor: {
                id: "",
                nama: "",
            },
            status: "",
            foto: "",
            NCSISTIME: "",
        }
    },

    mutations: {
        toggleModal(state, value) {
            state.modalEdit = value
        },
        viewModal(state, value) {
            state.user = value
        }
    }
})
